import type { FileValidationResult, ReferenceType } from "../types/reference";

const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

export function validateFiles(files: File[], type: ReferenceType): FileValidationResult {
  const validFiles: File[] = [];
  const errors: string[] = [];
  
  for (const file of files) {
    // Check file size
    if (file.size > MAX_FILE_SIZE) {
      errors.push(`"${file.name}" is too large (max 50MB)`);
      continue;
    }
    
    // Basic file type validation - be more permissive
    const isImage = file.type.startsWith('image/');
    const isVideo = file.type.startsWith('video/');
    
    // For flow type, allow both images and videos
    if (type === "flow") {
      if (!isImage && !isVideo) {
        errors.push(`"${file.name}" must be an image or video file`);
        continue;
      }
    } else {
      // For other types, primarily expect images but be flexible
      if (!isImage && !isVideo) {
        errors.push(`"${file.name}" must be an image file`);
        continue;
      }
    }
    
    validFiles.push(file);
  }
  
  return { validFiles, errors };
} 